import { ToastOptions, toast } from 'react-toastify'

const DEFAULT_OPTIONS: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  pauseOnFocusLoss: false,
  closeButton: true,
}

const broadcastNotification = (
  title: string,
  type: 'success' | 'error' | 'warning' | 'info',
  duration: number,
  showIcon: boolean
): string | number => {
  const options: ToastOptions = {
    ...DEFAULT_OPTIONS,
    autoClose: duration || false,
    ...(!showIcon ? { icon: false } : {}),
  }

  return toast[type](title, options)
}

const removeAllNotifications = () => {
  toast.dismiss()
}

const removeNotification = (id: string | number) => {
  toast.dismiss(id)
}

const notifySuccess = (title: string, showIcon = false, duration = 5000) =>
  broadcastNotification(title, 'success', duration, showIcon)

const notifyError = (title: string, showIcon = false, duration = 5000) =>
  broadcastNotification(title, 'error', duration, showIcon)

const notifyWarning = (title: string, showIcon = false, duration = 5000) =>
  broadcastNotification(title, 'warning', duration, showIcon)

export {
  notifySuccess,
  notifyError,
  notifyWarning,
  removeAllNotifications,
  removeNotification,
}
